import React from 'react';
import Tag from '../../../../../../muiComponents/Tag';
import {
    STATUS_TAG_COLORS,
    STATUS_KEYS,
} from '../../../../utils/zitoneoServicesUtils';
import ConnectivityLogsStatus from './ConnectivityLogsStatus';

interface ConnectivityLogsStatusBadgeProps {
    published: boolean;
}

const ConnectivityLogsStatusBadge = ({
    published,
}: ConnectivityLogsStatusBadgeProps) => {
    const statusColor =
        STATUS_TAG_COLORS[
            (published
                ? STATUS_KEYS.PUBLISHED
                : STATUS_KEYS.NOT_STARTED) as keyof typeof STATUS_TAG_COLORS
        ];

    return (
        <div className='flex flex-align-center flex-between gap-10'>
            <ConnectivityLogsStatus
                published={published}
                isVisibleText={true}
            />
            <Tag
                text={published ? 'live' : 'offline'}
                variant='outlined'
                color={statusColor}
                uppercase
            />
        </div>
    );
};

export default ConnectivityLogsStatusBadge;
